import { FC } from 'react'
import {
  Box,
  Chip,
  TableCell,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { Activity } from '../../../../services'
import { getDisplayDateTime } from '../../../../utils'
import { getActivityTone } from './activityTitleStyle'

export interface SiteActivityTableRowProps {
  activity: Activity
}

export const SiteActivityTableRow: FC<SiteActivityTableRowProps> = ({
  activity,
}) => {
  const theme = useTheme()
  const isCompact = useMediaQuery(theme.breakpoints.down('md'))
  const { activityTitle, activityByName, activityDescription, createDate } =
    activity
  const tone = getActivityTone(activityTitle)

  return (
    <TableRow
      hover
      sx={{
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
        },
      }}
    >
      <TableCell
        sx={{
          width: '14%',
          color: 'text.secondary',
          whiteSpace: 'nowrap',
          verticalAlign: 'top',
          py: 1.25,
          fontSize: '0.8125rem',
        }}
      >
        {getDisplayDateTime(createDate)}
      </TableCell>
      <TableCell
        sx={{
          width: '26%',
          verticalAlign: 'top',
          py: 1.25,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, color: 'text.primary' }}
          >
            {activityTitle}
          </Typography>
          {tone.chipLabel ? (
            <Chip
              label={tone.chipLabel}
              size="small"
              sx={{
                height: 20,
                fontSize: '0.6875rem',
                fontWeight: 600,
                backgroundColor: `${tone.accent}22`,
                color: tone.accent,
              }}
            />
          ) : null}
        </Box>
      </TableCell>
      <TableCell
        sx={{
          width: isCompact ? '60%' : '40%',
          verticalAlign: 'top',
          py: 1.25,
        }}
      >
        {activityDescription ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {activityDescription}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.disabled">
            —
          </Typography>
        )}
        {isCompact && activityByName ? (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 0.5, display: 'block' }}
          >
            by {activityByName}
          </Typography>
        ) : null}
      </TableCell>
      {!isCompact && (
        <TableCell
          sx={{
            width: '20%',
            verticalAlign: 'top',
            py: 1.25,
            color: 'text.secondary',
          }}
        >
          {activityByName || '—'}
        </TableCell>
      )}
    </TableRow>
  )
}

export default SiteActivityTableRow
